import dayjs from 'dayjs';
import React, { Fragment } from 'react';
import { StopTravelStatus, StopType } from '../../../redux/type';
// eslint-disable-next-line no-unused-vars
import { StopListItem } from '../../../utils/formatType';
import StopIcon from './StopIcon';
const TipMessage = (props: {
  item: StopListItem;
  // index: number;
  type: any;
  taskType: string;
}) => {
  const { item, type, taskType } = props;
  const tipInfoMap: any = new Map([
    [
      'LOAD',
      [
        {
          lable: '该点应装载：',
          value:
            item.totalDeliveryOrderNum >= 0 ? item.totalDeliveryOrderNum : '--',
        },
        {
          lable: '已装载：',
          value:
            item.finishedDeliveryOrderNum >= 0
              ? item.finishedDeliveryOrderNum
              : '--',
        },
      ],
    ],
    [
      'PICKUP',
      [
        item.totalDeliveryOrderNum
          ? {
              lable: '已妥投订单数：',
              value:
                item.finishedDeliveryOrderNum +
                '/' +
                item.totalDeliveryOrderNum,
            }
          : false,
        item.totalCollectOrderNum > 0
          ? {
              lable: '已揽收订单：',
              value:
                item.finishedCollectOrderNum + '/' + item.totalCollectOrderNum,
            }
          : false,
      ].filter(Boolean),
    ],
    [
      'DROPOFF',
      [
        item.totalDeliveryOrderNum
          ? {
              lable: '已妥投订单数：',
              value:
                item.finishedDeliveryOrderNum +
                '/' +
                item.totalDeliveryOrderNum,
            }
          : false,
        item.totalCollectOrderNum > 0
          ? {
              lable: '已揽收订单：',
              value:
                item.finishedCollectOrderNum + '/' + item.totalCollectOrderNum,
            }
          : false,
      ].filter(Boolean),
    ],
    [
      'UNLOAD',
      [
        {
          lable: '该点应卸载：',
          value:
            item.totalDeliveryOrderNum >= 0 ? item.totalDeliveryOrderNum : '--',
        },
        {
          lable: '已卸载：',
          value:
            item.totalCollectOrderNum >= 0 ? item.totalCollectOrderNum : '--',
        },
      ],
    ],
  ]);

  if (type === 'LOAD' && item.canceledDeliveryOrderNum) {
    tipInfoMap.get(type)!.push({
      lable: '订单取消：',
      value: item.canceledDeliveryOrderNum,
    });
  }
  const formatType = () => {
    let tipsIfo = ``;
    const fieldInfo = tipInfoMap.get(type);
    if (fieldInfo) {
      fieldInfo.forEach((item: { lable: string; value: number | string }) => {
        tipsIfo += `${item.lable}${item.value}\n`;
      });
    }
    return tipsIfo;
  };
  if (type === 'START') {
    return (
      <>
        {item.departTime ? (
          <div style={{ color: 'rgba(255,255,255,0.8)' }}>
            <StopIcon
              type={type}
              stopName={item.title}
              taskType={taskType}
            ></StopIcon>
            出发时间：{dayjs(item.departTime).format('HH:mm:ss')}
          </div>
        ) : (
          <div style={{ color: 'rgba(255,255,255,0.8)' }}>出发时间：--</div>
        )}
      </>
    );
  } else if (type === 'RETURN') {
    return (
      <span style={{ whiteSpace: 'pre-line', color: 'rgba(255,255,255,0.8)' }}>
        <StopIcon
          type={type}
          stopName={item.title}
          taskType={taskType}
        ></StopIcon>
        {typeof item.totalDeliveryOrderNum === 'number' &&
        item.totalDeliveryOrderNum !== 0
          ? ` 该点应卸载：${item.totalDeliveryOrderNum} \n`
          : ''}
        {item.arrivedTime &&
          `到达时间：${dayjs(item.arrivedTime).format('HH:mm:ss')}`}
      </span>
    );
  } else {
    return (
      <div>
        <StopIcon
          type={type}
          stopName={item.title}
          taskType={taskType}
        ></StopIcon>
        <div className='schedule_detail_box'>
          <div className='schedule_order' style={{ whiteSpace: 'pre-line' }}>
            {formatType()}
          </div>
          <div className='schedule_time'>
            {item.travelStatus !== StopTravelStatus.SKIP && (
              <>
                到达时间：
                {item.arrivedTime
                  ? dayjs(item.arrivedTime).format('HH:mm:ss')
                  : '--'}
                <br />
                {[StopTravelStatus.START, StopTravelStatus.STAY].includes(
                  item.travelStatus,
                )
                  ? ''
                  : item.departTime && (
                      <>出发时间：{dayjs(item.departTime).format('HH:mm:ss')}</>
                    )}
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
};
export default React.memo(TipMessage);
